import request from 'local_modules/request'
import { constants } from 'helpers'
import { reducers, getState } from 'redux/core'


const setFetching = (isFetching) => reducers.marketplace.adminConfigSchoolsPage.setFetching(isFetching)

const fetchSchools = () => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.get(prefix.schools + `?all=true`)
    .then(({ data }) => data)
    .then((schools) => {
      reducers.marketplace.adminConfigSchoolsPage.setSchools(schools)
    })
    .catch((error) => {
      console.log(error)
    })
}

const setSchools = (schools) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.post(prefix.schools + `?all=true`, schools)
    .then(({ data }) => data)
    .catch((error) => {
      console.log(error)
    })
}


export default {
  setFetching,
  fetchSchools,
  setSchools,
}
